module.exports = __webpack_public_path__ + "img/Medical_Case_pic01.179d3810.jpg";